import {AppService} from "../typescript/app/app.service";
import {PageResponse} from "../typescript/util/page-response";
import {ComissionProduct} from "./comission-product";
import {UserService} from "../user/user.service";
import {ComissionProductItem} from "./comission-product-item";
import {ProductService} from "../product/product.service";

class ComissionProductService {

    static API_URL = "/api/comissionproducts";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<ComissionProduct>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            username: sort?.startsWith('username') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }

    static save(item: ComissionProduct) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createComissionProduct() {
        const comissionProduct: ComissionProduct = {
            user: UserService.createUser(),
            comissionValue: '',
            items: [],
            document: null
        }
        return comissionProduct;
    }

    static createComissionProductItem() {
        const comissionProductItem: ComissionProductItem = {
            product: ProductService.createProduct(),
            quantity: ''
        }
        return comissionProductItem;
    }
}

export {ComissionProductService};